// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** /core/client/rawr/style/PoweredBy.scss
 ** module id = 1354
 ** module chunks = 5 7 8
 **/